import React, { useState } from "react";
import { useAuth } from "@/contexts/AuthContext";
import { useNavigate, Navigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Flame } from "lucide-react";

export default function Login() {
  const { user, login, error } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  if (user && user.email) return <Navigate to="/" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    const ok = await login(email, password);
    setLoading(false);
    if (ok) navigate("/");
  };

  return (
    <div className="min-h-screen grid lg:grid-cols-2">
      <div
        className="relative hidden lg:block"
        style={{
          backgroundImage: "url(https://images.pexels.com/photos/36397990/pexels-photo-36397990.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940)",
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      >
        <div className="absolute inset-0 bg-slate-950/80" />
        <div className="relative z-10 h-full flex flex-col p-12 text-white">
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 rounded-md bg-primary grid place-items-center">
              <Flame size={22} />
            </div>
            <div>
              <div className="font-heading font-black text-lg leading-none">REFRAKTER</div>
              <div className="text-[10px] uppercase tracking-widest text-slate-300">Birleşik Teklif Sistemi</div>
            </div>
          </div>
          <div className="mt-auto">
            <h2 className="font-heading text-4xl font-black leading-tight">
              Malzeme, işçilik ve<br/>karma projeler için<br/>tek motor.
            </h2>
            <p className="mt-4 text-slate-300 max-w-md text-sm">
              14 sayfalı formüllü Excel, canlı maliyet-kâr hesabı, tedarikçi karşılaştırma ve TCMB kur otomasyonu.
            </p>
          </div>
        </div>
      </div>
      <div className="flex items-center justify-center px-6 py-12 bg-background">
        <form onSubmit={submit} className="w-full max-w-md">
          <h1 className="font-heading text-3xl font-bold tracking-tight">Oturum Aç</h1>
          <p className="text-sm text-muted-foreground mt-1">Hesabınızla devam edin.</p>
          <div className="mt-8 space-y-4">
            <div>
              <Label htmlFor="email">E-posta</Label>
              <Input
                id="email" type="email" required
                data-testid="login-email"
                value={email} onChange={(e) => setEmail(e.target.value)}
                className="mt-1"
              />
            </div>
            <div>
              <Label htmlFor="password">Parola</Label>
              <Input
                id="password" type="password" required
                data-testid="login-password"
                value={password} onChange={(e) => setPassword(e.target.value)}
                className="mt-1"
              />
            </div>
            {error && (
              <div data-testid="login-error" className="text-sm text-destructive bg-destructive/10 rounded-md px-3 py-2">
                {error}
              </div>
            )}
            <Button
              type="submit" data-testid="login-submit"
              className="w-full bg-primary hover:bg-orange-600 text-white"
              disabled={loading}
            >
              {loading ? "Giriş yapılıyor..." : "Giriş Yap"}
            </Button>
            <p className="text-xs text-muted-foreground text-center">
              Sistem yöneticisi hesabınızı hazırladı. Sorun yaşarsanız yöneticinize başvurun.
            </p>
          </div>
        </form>
      </div>
    </div>
  );
}
